import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { AdalService } from '../shared/services/adal.service';
import { AuthenticationService } from '../shared/authentication/authentication.service';
import { EnvService } from '../shared/services/env.service';
import { UserService } from '../Users/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UserIdleService } from 'angular-user-idle';
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  showUserProfileDiv: boolean = false;
  username:string="";
  @Input() userImage: any;
  userEmail:string="";
  @Input() displayUserName: string;
  showModal: boolean = false;
  isSessionExpired: boolean = false;
  constructor(private router: Router, private msal: MsalService, private authService: AuthenticationService, private userService: UserService, private sanitizer : DomSanitizer, private userIdle: UserIdleService) { }

  ngOnInit() {
    setTimeout(() => {
      this.authService.userProfile.subscribe((data) => {
        if(data.userName){
        var names = data.userName.split(',');
        if(names && names.length>1)
        this.username=names[names.length-1]+" "+names[0]
        this.userImage=data.imageUrl;
        this.userEmail=data.userId;
        this.displayUserName=this.username;
        }
    });
   
  // this.getImageFromGraphService("https://graph.microsoft.com/v1.0/users/198cacf0-5ac9-4b85-bf73-3bf3ac1e053b/photo/$value");
  // this.userImage="https://graph.microsoft.com/v1.0/users/198cacf0-5ac9-4b85-bf73-3bf3ac1e053b/photo/$value";
   },3000);
  
     //Start watching for user inactivity.
     this.userIdle.startWatching();
    
     // Start watching when user idle is starting.
     this.userIdle.onTimerStart().subscribe(count => this.showSessionTimeOutPopup(count));
     
     // Start watch when time is up.
     this.userIdle.onTimeout().subscribe(() => { console.log('Time is up!');
     this.showModal=false;
     this.msal.logout();
    });
  }
  showSessionTimeOutPopup(count)
  {
    this.closeDropdown(null);
    let body = document.getElementsByTagName('body')[0];
    body.classList.add("overflowFixed");   //add the class
    this.isSessionExpired=true;
    this.showModal = true;
  }
  redirectToProfile()
  {
    this.closeDropdown(null);
    this.router.navigate(['user/profile',{ fromUserPage: false }]);
  }

  signout()
  {
    //this.adal.logout();
    //add overflow hidden to body on modal open
    this.closeDropdown(null);
    let body = document.getElementsByTagName('body')[0];
    body.classList.add("overflowFixed");   //add the class
  
    this.showModal = true;
  }

  getImageFromGraphService(imageUrl:string) {
  
     this.userService.getUserImage(imageUrl).subscribe((data:any) => {
      this.userImage = this.createImageFromBlobAndReturn(data.body);
  });

  }
  close($event) {
    this.showModal=false;
    this.isSessionExpired=false;
  }
  
createImageFromBlobAndReturn(image: any):any {
  
  var binaryData = [];
  binaryData.push(image);
  
  var reader = new FileReader();
  reader.readAsBinaryString(new Blob(binaryData));
  
  const imageFile = new File([new Blob(binaryData)], "");
  let base64data = window.URL.createObjectURL(imageFile);
  console.log(this.sanitizer.bypassSecurityTrustUrl(base64data));
  return this.sanitizer.bypassSecurityTrustUrl(base64data);
  
  }
  closeDropdown(event: any)
  {
   this.showUserProfileDiv=false;
  }
  showUserPopup()
  {
    this.showUserProfileDiv=!this.showUserProfileDiv;
    event.stopPropagation();
  }
}
